<template>
	<div class="create_order">
		<div class="shop_top">
			<shop-top :subnav_show="false" :change_color="true"></shop-top>
		</div>

		<div class="join_over width_center_1200">
			<div class="join_bzt">
				<el-steps :active="2" finish-status="process" simple>
					<el-step title="我的购物车" icon="el-icon-shopping-cart-full"></el-step>
					<el-step title="物流地址" icon="el-icon-map-location"></el-step>
					<el-step title="选择支付" icon="el-icon-mouse"></el-step>
					<el-step title="支付成功" icon="el-icon-check"></el-step>
				</el-steps>
			</div>
		</div>

		<div class="address_chose width_center_1200">
			<div class="address_chose_title">
				选择支付方式
			</div>
			<div class="pay_list">
				<ul>
					<li @click="pay('wxpay_native')">
						<el-image src="/pc/pc_wxpay.jpg"></el-image>
					</li>
					<li @click="pay('alipay_native')">
						<el-image src="/pc/pc_alipay.jpg"></el-image>
					</li>
					<li @click="pay('fast_pay')">
						<el-image src="/pc/pc_fastpay.jpg"></el-image>
					</li>					
				</ul>
			</div>

			<div class="address_chose_title">
				订单商品信息
			</div>
			<div class="order_list_title">
				<el-row>
					<el-col :span="10">
						<div class="th_title">商品信息</div>
					</el-col>
					<el-col :span="4">
						<div class="th_title">属性信息</div>
					</el-col>
					<el-col :span="4">
						<div class="th_title">单价</div>
					</el-col>
					<el-col :span="2">
						<div class="th_title">数量</div>
					</el-col>
					<el-col :span="2">
						<div class="th_title">税费</div>
					</el-col>
					<el-col :span="2">
						<div class="th_title">小计</div>
					</el-col>
				</el-row>
			</div>

			<div class="store_list">
				<!-- <div class="store_info">
                    <dl>
                        <dt><el-image :src="v[0].store_logo"></el-image></dt>
                        <dd>{{v[0].store_name}}</dd>
                    </dl>
                    <div class="clear"></div>
                </div> -->
				<div class="order_list">
					<ul>
						<li v-for="(vo,key) in befor_order_list" :key="key">
							<el-row>
								<el-col :span="10">
									<div class="goods_info">
										<dl>
											<dt>
												<el-image :src="vo.imgurl"></el-image>
											</dt>
											<dd>{{vo.name}}</dd>
										</dl>
									</div>
								</el-col>
								<el-col :span="4">
									<div class="th_title">{{$isEmpty(vo.snCode)?' - ':vo.snCode}}</div>
								</el-col>
								<el-col :span="4">
									<div class="th_title">￥{{vo.price}}</div>
								</el-col>
								<el-col :span="2">
									<div class="th_title" style="text-indent:30px;">x {{vo.num}}</div>
								</el-col>
								<el-col :span="2">
									<div class="th_title" style="text-indent:40px;">￥{{vo.taxPrice}} </div>
								</el-col>
								<el-col :span="2">
									<div class="x_price" style="text-indent:30px;">￥{{vo.total}}</div>
								</el-col>
							</el-row>
						</li>
					</ul>
				</div>
			</div>

			<div class="address_chose_title" v-if="createOrderInfo.remark">
				订单备注
			</div>
			<div class="store_list">
				{{createOrderInfo.remark}}
			</div>
			<!-- 二维码扫描 -->
			<el-dialog :title="'请用'+(payWay==4?'微信':'支付宝')+ '扫码支付'" :visible.sync="dialogVisible" width="260px" :before-close="payClose">
				<div class="scan_qr">
					<div style="width:200px;height:230px;">
						<div id="qrcode" class="qrcode" ref="qrCodeUrl"></div>
					</div>
					<!-- <el-image :src="qr_code"></el-image> -->
				</div>
			</el-dialog>



			<div class="foot_create_order">
				<div class="total_price">
					<span>结算：</span>
					￥ {{total_price}}
					<font>( {{total_freight>0?'运费:'+total_freight:'免运费'}} )</font>
				</div>
			</div>
		</div>

		<!-- 快捷支付 -->
		<el-dialog title="快捷支付" :visible.sync="fastpayVisible" width="450px" :before-close="payClose">
			<div style="text-align: center;">
				<p>支付金额：</p>
				<p style="color: #F56C6C;"><span>¥ </span><span style="font-size: 3em;">{{total_price}}</span></p>
			</div>
			<div class="fast-pay">
				<el-divider></el-divider>
				<el-form :model="fastpayInfo" :rules="fastpayRules" ref="formFastPay" label-width="120px">
					<el-form-item label="银行卡号" prop="accountNumber">
						<el-input type="text" placeholder="请输入已签约的银行卡号" v-model="fastpayInfo.accountNumber"
							maxlength="19" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="短信验证码" prop="smsCode">
						<el-input type="text" placeholder="请输入短信验证码" v-model="fastpayInfo.smsCode" maxlength="8"
							show-word-limit>
							<el-button slot="append" @click="sendSms" :disabled="sendSmsButton.isDisabled">
								{{sendSmsButton.buttonName}}</el-button>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-link type="primary" @click="gotoSign">去签约</el-link>
					</el-form-item>
				</el-form>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" @click="fastPayConfirm">确认支付</el-button>
			</span>
		</el-dialog>

		<!-- 快捷支付签约 -->
		<el-dialog title="快捷支付签约" :visible.sync="fastpaySignVisible" width="30%">
			<div class="fast-pay">
				<el-form :model="fastpaySignInfo" :rules="fastpaySignRules" ref="formFastPaySign" label-width="120px">
					<el-form-item label="银行卡号" prop="accountNumber">
						<el-input type="text" placeholder="输入需要签约的银行卡号" v-model="fastpaySignInfo.accountNumber"
							maxlength="19" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="账户类型" prop="accountType">
						<el-select v-model="fastpaySignInfo.accountType" placeholder="请选择账户类型">
							<el-option label="借记卡" value="00">
							</el-option>
							<el-option label="贷记卡" value="01">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile">
						<el-input type="text" placeholder="请输入手机号" v-model="fastpaySignInfo.mobile" maxlength="11"
							show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" @click="fastPaySignConfirm">确认签约</el-button>
			</span>
		</el-dialog>

		<shop-foot></shop-foot>
		<!-- vue 回到顶部 -->
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import ShopTop from "@/components/home/public/head.vue"
	import ShopFoot from "@/components/home/public/shop_foot.vue"
	import {
		preCreateOrderInfo,
		createOrderAndBackWaitePayInfo,
		getOrderTagByOrdersId,
		getOrderInfo,
		getPayQrCode,
		unionPaymentSign,
		unionPaymentSmsSend,
		unionPaymentPayWithSms
	} from "@/api/api"
	export default {
		components: {
			ShopTop,
			ShopFoot,
		},
		props: {},
		data() {
			return {
				payWay:4,
				waitPayOrdersId: null, //后台已经创建成功，待付款的订单id
				befor_order_list: [],
				total_price: 0,
				total_freight: 0,
				dialogVisible: false,
				fastpayVisible: false,
				fastpayRules: {
					accountNumber: [{
						required: true,
						message: '请输入银行卡号',
						trigger: 'blur'
					}],
					smsCode: [{
						required: true,
						message: '请输入短信验证码',
						trigger: 'blur'
					}],
				},
				fastpaySignVisible: false,
				fastpaySignRules: {
					accountNumber: [{
						required: true,
						message: '输入需要签约的银行卡号',
						trigger: 'blur'
					}],
					accountType: [{
						required: true,
						message: '请选择账户类型',
						trigger: 'change'
					}],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						min: 11,
						max: 11,
						message: '请输入11位手机号',
						trigger: 'blur'
					}],
				},
				fastpayInfo: {},
				fastpaySignInfo: {},
				qr_code: '',
				checkPayTime: 30, //订单状态查询次数，为0是不要再定时查了
				timeObj: null,
				preOrderData: {},
				seller_order_id: 0, //点击微信支付后台创建的订单id
				createOrderInfo: {},
				sendSmsButton: {
					buttonName: '获取',
					isDisabled: false,
					time: 10
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			// 根据购物车的数据或者商品的数据来获取订单的数据
			preCreateOrderInfo: function() {
				let that = this
				let info = this.$route.params
				that.createOrderInfo = info;
				let param = {
					business_type: "base",
					coupon_codes: [],
					address_id: info.addressId,
					items: info.items
				}
				preCreateOrderInfo(param).then(res => {
					if (res.code == 0) {
						that.preOrderData = res.data;
						that.befor_order_list = res.data.orderItems;
						that.total_price = res.data.totalPayPrice;
						that.total_freight = res.data.transPrice;
					} else {
						this.$message.error('获取订单数据失败:'+res.msg);
					}
				});
			},
			// 支付
			pay: function(payment_name) {
				let that = this
				let payWay = that.getPayWay(payment_name);
				that.payWay = payWay;
				if (that.waitPayOrdersId) {
					if (payment_name == 'wxpay_native' || payment_name == 'alipay_native') {
						//已经生成订单的 刷新付款码
						return getPayQrCode(that.waitPayOrdersId,payWay).then(res => {
							if (res.code == 0 && res.data.indexOf('http') === 0) {
								this.seller_order_id = that.waitPayOrdersId
								this.qr_code = res.data;
								this.dialogVisible = true;
								this.createPayQrCode()
								this.checkPayTime = 30;
								this.timeObj = setInterval(() => {
									this.check_pay();
								}, 2000);
							}else{
								this.$message.error('调起支付失败:'+res.data);
							}
						})
					}else if (payment_name == 'fast_pay') {
						this.fastpayInfo.pid = that.waitPayOrdersId;
						this.fastpayVisible = true
					}

				}
				let payType = "WeChat" //支付类型(Wechat,EasyPay,NeoPay)
				if (that.preOrderData.wxAppPayTypes) {
					let rows = that.preOrderData.wxAppPayTypes.filter(f => f.payChannel == 'WeChat')
					if (rows.length >= 1) {
						payType = rows[0].payType
					}
				}
				if (payment_name == 'wxpay_native' || payment_name == 'alipay_native' || payment_name == 'fast_pay'){
					payType = 'NeoPay'
				}
				let data = {
					payWay: payWay,
					pay_type: payType,
					addres_id: that.preOrderData.address.addresId,
					coupon_codes: [],
					business_type: "base",
					cus_note: that.remark,
					open_id: that.open_id,
					items: that.preOrderData.orderItems.map(m => {
						return {
							business_product_id: m.productId,
							share_goods_id: m.shareGoodsId,
							orderType: 1,
							qty: m.num,
							prods_price: m.price,
							tax_price: m.taxPrice
						}
					}),
					prods_price: that.preOrderData.totalProductPrice,
					total_price: that.preOrderData.totalPayPrice,
					trans_price: that.preOrderData.transPrice,
					promotionsId: that.preOrderData.promotionsId,
					promotionsDesc: that.preOrderData.promotionsDesc,
					promotionsPrice: that.preOrderData.promotionsPrice,
					tax_price: that.preOrderData.taxPrice
				}
				createOrderAndBackWaitePayInfo(data).then(res => {
					if (res.code == 0) {
						if (payment_name == 'wxpay_native' || payment_name == 'alipay_native') {
							this.seller_order_id = res.data.seller_order_id
							this.qr_code = res.data.mwebUrl;
							this.dialogVisible = true;
							this.createPayQrCode();
							this.checkPayTime = 30;
							this.timeObj = setInterval(() => {
								this.check_pay();
							}, 2000);
						} else if (payment_name == 'fast_pay') {
							this.fastpayInfo.pid = res.data.seller_order_id;
							this.fastpayVisible = true
						} else {
							const div = document.createElement('div') // 创建div
							div.innerHTML = res.data // 将返回的form 放入div
							document.body.appendChild(div)
							document.forms[0].submit()
						}
					} else {
						this.$message.error('调起支付失败:'+res.msg);
					}
				});
			},
			//获取支付方式
			getPayWay:function(payment_name){
				let payWay = 4;
				switch(payment_name){
					case 'wxpay_native':{//4:PC端微信扫码支付；
						payWay = 4;
						break;
					}
					case 'fast_pay':{//5:快捷支付
						payWay = 5;
						break;
					}
					case 'alipay_native':{//6:PC端支付宝扫码支付；
						payWay = 6;
						break;
					}
				}
				return payWay
			},
			// 定时查询是否支付成功
			check_pay: function(out_trade_no) {
				if (this.checkPayTime == 0) {
					//剩余查询次数为0了不用继续定时查询状态
					clearInterval(this.timeObj);
					return;
				}
				this.checkPayTime--;
				getOrderTagByOrdersId(this.seller_order_id).then(res => {
					if (res.code == 0 && res.data == '2') {
						//已付款状态停止定时器，跳转至支付成功页面
						clearInterval(this.timeObj);
						this.$router.push({
							name: 'home_pay_success',
							params: {
								paySuccess: true
							}
						});
					} else if (res.code !== 0) {
						clearInterval(this.timeObj);
					}
				});
			},
			//关闭支付
			payClose(done) {
				this.$confirm('确认取消支付？')
					.then(_ => {
						if (this.timeObj) {
							clearInterval(this.timeObj);
						}
						this.$router.push({
							name: 'home_pay_success',
							params: {
								paySuccess: false
							}
						});
						done();
					})
					.catch(_ => {});
			},
			//创建支付二维码
			createPayQrCode() {
				let that = this;
				this.$nextTick(() => {
					let qrcode = new QRCode(that.$refs.qrCodeUrl, {
						text: that.qr_code, // 需要转换为二维码的内容
						width: 220,
						height: 220,
						colorDark: "#000000",
						colorLight: "#ffffff",
						correctLevel: QRCode.CorrectLevel.H,
					});
				})
			},
			//快捷支付去签约
			gotoSign() {
				this.fastpayVisible = false;
				this.fastpaySignVisible = true;
			},
			//确认快捷支付
			fastPayConfirm() {
				this.$refs['formFastPay'].validate((valid) => {
					if (valid) {
						this.fastpayInfo.amount = this.total_price;
						unionPaymentPayWithSms(this.fastpayInfo).then(res => {
							if (res.code == 0) {
								this.$router.push({
									name: 'home_pay_success',
									params: {
										paySuccess: true
									}
								});
							} else {
								this.$message.error(res.data)
								return false;
							}
						})
					} else {
						return false;
					}
				});
			},
			//确认签约
			fastPaySignConfirm() {
				this.$refs['formFastPaySign'].validate((valid) => {
					if (valid) {
						unionPaymentSign(this.fastpaySignInfo).then(res => {
							if (res.code == 0) {
								this.fastpaySignVisible = false;
								this.fastpayVisible = true;
								let signPage = window.open('',"_blank")
								signPage.document.write(res.data)
							} else {
								this.$message.error(res.data)
								return false;
							}
						})
					} else {
						return false;
					}
				});
			},
			//获取快捷支付短信验证码
			sendSms() {
				let me = this.sendSmsButton;
				if (!this.fastpayInfo.accountNumber || this.fastpayInfo.accountNumber.length < 16 || this.fastpayInfo
					.accountNumber.length > 19) {
					this.$message.warning("请填写您已签约的银行卡号(16~19位)")
					return false;
				}
				unionPaymentSmsSend(this.fastpayInfo.accountNumber, this.total_price).then(res => {
					if (res.code == 0) {
						me.isDisabled = true;
						let interval = setInterval(() => {
							me.buttonName = me.time + '秒后重新获取'
								--me.time;
							if (me.time < 0) {
								me.buttonName = '获取',
									me.time = 60;
								me.isDisabled = false;
								clearInterval(interval);
							}
						}, 1000)
						this.$message.success("短信验证码已发送您签约绑定的手机，请及时查收")
					} else {
						this.$message.error(res.data)
						return false;
					}
				})
			}
		},
		created() {
			let ordersId = this.$route.params.ordersId
			if (ordersId && ordersId > 0) {
				this.waitPayOrdersId = ordersId;
				getOrderInfo(ordersId).then(res => {
					if (res.code == 0) {
						this.befor_order_list = res.data.orderItemVOs.map(m => {
							return {
								imgurl: m.imgurl,
								snCode: m.sn_code,
								price: m.prodsPrice,
								num: m.prodsNum,
								taxPrice: m.taxPrice,
								total: m.totalPrice
							}
						})
						this.total_price = res.data.payPrice
						this.total_freight = res.data.transPrice
					}
				})
			} else {
				this.preCreateOrderInfo();
			}
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.scan_qr {
		text-align: center;
	}

	.empty_address {
		margin-bottom: 80px;
		line-height: 105px;
		border: 3px solid #efefef;
		border-radius: 3px;
		text-align: center;
		width: 292px;
		height: 105px;

		span {
			color: #ca151e;
		}

		a:hover {
			color: #ca151e;
		}
	}

	.join_bzt {
		margin-top: 40px;
	}

	.foot_create_order {
		margin-top: 50px;
		float: right;
		margin-right: 30px;

		.total_price {
			font-size: 28px;
			color: #ca151e;
			line-height: 28px;

			span {
				float: left;
				font-size: 14px;
				color: #333;

			}

			font {
				float: right;
				font-size: 14px;
				color: #666;
				margin-left: 20px;
			}
		}

		.foot_create_order_btn {
			float: right;
			margin-top: 20px;
			margin-bottom: 40px;
		}
	}

	.store_list {
		.store_info {
			margin-top: 20px;
			margin-left: 15px;

			dl dt {
				width: 30px;
				height: 30px;
				border-radius: 50%;
				background: #f1f1f1;
				float: left;
				margin-right: 15px;
			}

			dl dd {
				float: left;
				line-height: 30px;
			}
		}

		ul li {
			border-bottom: 1px solid #efefef;
			padding-bottom: 20px;
			margin-bottom: 20px;

			.x_price {
				color: #ca151e;
			}

			text-indent: 20px;
		}

		ul li .goods_info {
			text-indent: 0px;
		}

		ul li:last-child {
			border-bottom: none;
			padding-bottom: 0px;
			margin-bottom: 0px;
		}

		.order_list {
			margin-top: 20px;
			color: #666;
			font-size: 12px;
			border: 1px solid #efefef;
			padding: 20px;
			line-height: 40px;

			.goods_info {
				dl dt {
					width: 40px;
					height: 40px;
					background: #f8f8f8;
					float: left;
					margin-right: 15px;
				}

				dl dd {
					line-height: 20px;
				}
			}
		}
	}

	.order_list_title {
		color: #666;
		background: #f2f2f2;
		line-height: 40px;
		text-indent: 20px;
	}

	.address_chose {
		margin-top: 75px;
		font-size: 14px;

		.pay_list {
			margin-bottom: 30px;

			ul:after {
				content: '';
				display: block;
				clear: both;
			}

			ul li {
				float: left;
				width: 292px;
				height: 105px;
				border-radius: 3px;
				border: 1px solid #efefef;
				margin-right: 20px;
				-webkit-transition: all .2s linear;
				transition: all .2s linear;
			}

			ul li:hover {
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			}
		}

		.address_chose_title {
			font-size: 16px;
			clear: both;
			font-weight: bold;
			padding-bottom: 20px;
			padding-top: 10px;
		}

	}
</style>
